const locationsMapRoots = document.querySelectorAll('[data-locations-map]');

if (locationsMapRoots.length && typeof window.L !== 'undefined') {
	const leaflet = window.L;

	const normalizeLocationText = (value) =>
		String(value || '')
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();

	const createElement = (tagName, className, text) => {
		const element = document.createElement(tagName);

		if (className) {
			element.className = className;
		}

		if (typeof text !== 'undefined' && text !== '') {
			element.textContent = text;
		}

		return element;
	};

	locationsMapRoots.forEach((root) => {
		const canvas = root.querySelector('[data-locations-map-canvas]');
		const dataElement = root.querySelector('.locationsmap__data');
		const details = root.querySelector('[data-locations-map-details]');
		const search = root.querySelector('[data-locations-map-search]');
		const searchResults = root.querySelector('[data-locations-map-results]');

		if (!canvas || !dataElement || !details || !search || !searchResults) {
			return;
		}

		let locations = [];

		try {
			locations = JSON.parse(dataElement.textContent || '[]');
		} catch (error) {
			return;
		}

		if (!Array.isArray(locations) || !locations.length) {
			return;
		}

		const map = leaflet.map(canvas, {
			center: [52.0693, 19.4803],
			zoom: 6,
			minZoom: 5,
			maxZoom: 18,
			scrollWheelZoom: false,
		});

		leaflet
			.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 19,
				attribution:
					'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
			})
			.addTo(map);

		const markerIcon = leaflet.divIcon({
			className: 'locationsmap__marker',
			html: '<span class="locationsmap__markerPin" aria-hidden="true"><span class="locationsmap__markerDot"></span></span>',
			iconSize: [38, 48],
			iconAnchor: [19, 46],
			popupAnchor: [0, -42],
		});

		const markers = typeof leaflet.markerClusterGroup === 'function'
			? leaflet.markerClusterGroup({
				showCoverageOnHover: false,
				spiderfyOnMaxZoom: true,
				disableClusteringAtZoom: 15,
				maxClusterRadius: 52,
				iconCreateFunction: (cluster) =>
					leaflet.divIcon({
						className: 'locationsmap__cluster',
						html: `<span class="locationsmap__clusterCount">${cluster.getChildCount()}</span>`,
						iconSize: [46, 46],
					}),
			})
			: leaflet.layerGroup();
		const markerByLocationId = new Map();
		let activeSearchResult = -1;

		const appendDetailRow = (list, label, value, url) => {
			if (!value) {
				return;
			}

			const row = createElement('div', 'locationsmap__metaRow');
			const term = createElement('dt', 'locationsmap__metaLabel', label);
			const description = createElement('dd', 'locationsmap__metaValue');

			if (url) {
				const link = createElement('a', 'locationsmap__metaLink', value);
				link.href = url;

				if (/^https?:/i.test(url)) {
					link.target = '_blank';
					link.rel = 'noopener noreferrer';
				}

				description.append(link);
			} else {
				description.textContent = value;
			}

			row.append(term, description);
			list.append(row);
		};

		const renderLocationDetails = (location) => {
			const card = createElement('article', 'locationsmap__card');

			if (location.image) {
				const image = createElement('img', 'locationsmap__image');
				image.src = location.image;
				image.alt = '';
				image.loading = 'lazy';
				card.append(image);
			}

			const cardBody = createElement('div', 'locationsmap__cardBody');

			cardBody.append(createElement('h3', 'locationsmap__cardHeading', location.name));

			const addressParts = [
				location.address,
				[location.postcode, location.city].filter(Boolean).join(' '),
			].filter(Boolean);

			if (addressParts.length) {
				const address = createElement('address', 'locationsmap__address');
				addressParts.forEach((part) => {
					address.append(createElement('span', 'locationsmap__addressLine', part));
				});
				cardBody.append(address);
			}

			const meta = createElement('dl', 'locationsmap__meta');
			appendDetailRow(meta, 'Telefon', location.phone, location.phoneUrl);
			appendDetailRow(
				meta,
				'E-mail',
				location.email,
				location.email ? `mailto:${location.email}` : ''
			);
			appendDetailRow(meta, 'Region', location.region);
			appendDetailRow(meta, 'Kraj', location.country);
			appendDetailRow(meta, 'Strona', location.website, location.website);

			if (meta.children.length) {
				cardBody.append(meta);
			}

			if (location.additionalInfo) {
				cardBody.append(
					createElement(
						'p',
						'locationsmap__additionalInfo',
						location.additionalInfo
					)
				);
			}

			const mapLink = createElement(
				'a',
				'locationsmap__mapLink',
				'Pokaż w Google Maps'
			);
			mapLink.href = location.mapUrl;
			mapLink.target = '_blank';
			mapLink.rel = 'noopener noreferrer';
			cardBody.append(mapLink);
			card.append(cardBody);
			details.replaceChildren(card);
		};

		const createPopup = (location) => {
			const popup = createElement('div', 'locationsmap__popup');
			popup.append(createElement('strong', 'locationsmap__popupHeading', location.name));

			const cityLine = [location.address, location.city].filter(Boolean).join(', ');
			if (cityLine) {
				popup.append(createElement('span', 'locationsmap__popupAddress', cityLine));
			}

			return popup;
		};

		const hideSearchResults = () => {
			searchResults.hidden = true;
			search.setAttribute('aria-expanded', 'false');
			search.removeAttribute('aria-activedescendant');
			activeSearchResult = -1;
		};

		const selectLocation = (location, marker, moveMap = true) => {
			renderLocationDetails(location);
			hideSearchResults();

			const showMarker = () => {
				if (moveMap) {
					map.setView([location.latitude, location.longitude], Math.max(map.getZoom(), 14));
				}

				marker.openPopup();
			};

			if (typeof markers.zoomToShowLayer === 'function') {
				markers.zoomToShowLayer(marker, showMarker);
			} else {
				showMarker();
			}

			if (window.matchMedia('(max-width: 767.98px)').matches) {
				window.setTimeout(() => {
					details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				}, 250);
			}
		};

		locations.forEach((location) => {
			const marker = leaflet.marker(
				[location.latitude, location.longitude],
				{
					icon: markerIcon,
					title: location.name,
					alt: location.name,
				}
			);

			marker.bindPopup(createPopup(location), {
				className: 'locationsmap__leafletPopup',
				closeButton: true,
			});
			marker.on('click', () => selectLocation(location, marker, false));
			markers.addLayer(marker);
			markerByLocationId.set(String(location.id), marker);
		});

		markers.addTo(map);

		const sortedLatitudes = locations
			.map((location) => location.latitude)
			.sort((first, second) => first - second);
		const sortedLongitudes = locations
			.map((location) => location.longitude)
			.sort((first, second) => first - second);
		const middleIndex = Math.floor(locations.length / 2);
		const medianLatitude = sortedLatitudes[middleIndex];
		const medianLongitude = sortedLongitudes[middleIndex];
		const initialLocations = locations.filter(
			(location) =>
				Math.abs(location.latitude - medianLatitude) <= 10 &&
				Math.abs(location.longitude - medianLongitude) <= 15
		);
		const bounds = leaflet.latLngBounds(
			(initialLocations.length ? initialLocations : locations).map((location) => [
				location.latitude,
				location.longitude,
			])
		);

		if (bounds.isValid()) {
			map.fitBounds(bounds, {
				padding: [32, 32],
				maxZoom: 7,
			});
		}

		const renderSearchResults = () => {
			const query = normalizeLocationText(search.value.trim());
			searchResults.replaceChildren();

			if (!query) {
				hideSearchResults();
				return;
			}

			const matches = locations
				.filter((location) => {
					const haystack = normalizeLocationText(
						[
							location.name,
							location.address,
							location.postcode,
							location.city,
							location.region,
						].join(' ')
					);

					return haystack.includes(query);
				})
				.slice(0, 12);

			if (!matches.length) {
				searchResults.append(
					createElement(
						'p',
						'locationsmap__searchEmpty',
						'Nie znaleziono punktu dla podanej frazy.'
					)
				);
			} else {
				matches.forEach((location, index) => {
					const result = createElement('button', 'locationsmap__searchResult');
					result.type = 'button';
					result.id = `${searchResults.id}-option-${index}`;
					result.setAttribute('role', 'option');
					result.setAttribute('aria-selected', 'false');
					result.append(
						createElement('strong', 'locationsmap__searchResultName', location.name),
						createElement(
							'span',
							'locationsmap__searchResultAddress',
							[location.address, location.postcode, location.city]
								.filter(Boolean)
								.join(', ')
						)
					);
					result.addEventListener('click', () => {
						const marker = markerByLocationId.get(String(location.id));

						if (marker) {
							selectLocation(location, marker);
						}
					});
					searchResults.append(result);
				});
			}

			searchResults.hidden = false;
			search.setAttribute('aria-expanded', 'true');
			activeSearchResult = -1;
			search.removeAttribute('aria-activedescendant');
		};

		const setActiveSearchResult = (index) => {
			const results = Array.from(
				searchResults.querySelectorAll('.locationsmap__searchResult')
			);

			if (!results.length) {
				return;
			}

			activeSearchResult = (index + results.length) % results.length;
			results.forEach((result, resultIndex) => {
				result.setAttribute(
					'aria-selected',
					resultIndex === activeSearchResult ? 'true' : 'false'
				);
			});
			search.setAttribute('aria-activedescendant', results[activeSearchResult].id);
			results[activeSearchResult].scrollIntoView({ block: 'nearest' });
		};

		search.addEventListener('input', renderSearchResults);
		search.addEventListener('focus', () => {
			if (search.value.trim()) {
				renderSearchResults();
			}
		});
		search.addEventListener('keydown', (event) => {
			const results = Array.from(
				searchResults.querySelectorAll('.locationsmap__searchResult')
			);

			if ('ArrowDown' === event.key && results.length) {
				event.preventDefault();
				setActiveSearchResult(activeSearchResult + 1);
				return;
			}

			if ('ArrowUp' === event.key && results.length) {
				event.preventDefault();
				setActiveSearchResult(activeSearchResult - 1);
				return;
			}

			if ('Enter' === event.key && activeSearchResult >= 0 && results[activeSearchResult]) {
				event.preventDefault();
				results[activeSearchResult].click();
				return;
			}

			if (event.key === 'Escape') {
				hideSearchResults();
			}
		});
		document.addEventListener('click', (event) => {
			if (!event.target.closest('.locationsmap__search')) {
				hideSearchResults();
			}
		});
		window.addEventListener('resize', () => map.invalidateSize());
		window.setTimeout(() => map.invalidateSize(), 0);
	});
}
